import React from 'react'
import LoginCard from '../components/LoginCard'

function LoginPage() {
  return (
    <div className="bg-black">
      <LoginCard/>
    </div>
  )
}

export default LoginPage